import { render, staticRenderFns } from "./JoiningKit.vue?vue&type=template&id=221263d3&scoped=true&"
import script from "./JoiningKit.vue?vue&type=script&lang=js&"
export * from "./JoiningKit.vue?vue&type=script&lang=js&"
import style0 from "./JoiningKit.vue?vue&type=style&index=0&id=221263d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221263d3",
  null
  
)

export default component.exports